export default {
  playRecording: 'Play Recording',
  stopPlayback: 'Stop Playback',
};
